const { VUE_APP_UC, NODE_ENV } = process.env
import { post } from '@/httpRequest/http.js'
import { isHLApp } from '@/utils'
let domain = ''
if (isHLApp() || NODE_ENV === 'production') domain = `${VUE_APP_UC}`
// 初始化交易密码
export const TradePasswordInit = data => post(domain + '/uc/v1/TradePasswordInit', { data })
// 重置交易密码
export const TradePasswordReset = data => {
    return post(domain + '/uc/v1/TradePasswordReset', { data })
}

// 交易登录
export const TradeLogin = data => {
    return post(domain + '/uc/v1/TradeLogin', { data })
}

// 修改交易密码 https://www.tapd.cn/60236733/markdown_wikis/show/#1160236733001000142@toc39
export const TradePasswordModify = data => {
    return post(domain + '/uc/v1/TradePasswordModify', { data })
}
